import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {COMMON_MODAL_STYLE} from "../../../helper/StyleHelper";
import {Col, Modal, Row, Table} from "react-bootstrap";
import {IoMdClose} from "react-icons/io";
import Datatables, {getCheckedItems} from "../../component/Datatables";
import axios from "axios";
import {toast} from "react-toastify";
import messageCodeDic from "../../../util/messageCodeDic";
import BMCSelect from "../../../components/common/BMCSelect";
import {getLoginUser} from "../../../helper/SecurityHelper";
import SHSearch from "../../component/BMCSearch";
import BMCInput from "../../../components/common/BMCInput";

interface IProps {
    setModalIsOpen: Dispatch<SetStateAction<boolean>>;
    modalIsOpen: boolean;
    mngrDataList: object[];
    setMngrDataList: Dispatch<SetStateAction<object[]>>;
    cmpnySeq: number
    companyGbCd: string;
    dprtCd?: string;

}

const $ = require("jquery")

const MngrSrchModal = (props: IProps) => {
    const [datatable, setDatatable] = useState<any>();
    const searchFormRef = useRef<any>();
    const user = getLoginUser();
    const [isCodeDataLoaded, setIsCodeDataLoaded] = useState<any>(null);
    const [mngrDataList, setMngrDataList] = useState<any>([props.mngrDataList]);
    const [userSeqList, setUserSeqList] = useState<number[]>([]);

    useEffect(() => {
        if(isCodeDataLoaded){
            fn_search();
        }
    }, [isCodeDataLoaded]);

    function fn_closeModal() {
        props.setModalIsOpen(false);
    }

    const fn_search = (e?: any) => {
        e?.preventDefault()
        datatable?.draw()
    }
    const fn_select = () => {
        if (mngrDataList.length == 0) {
            toast.warn('관리자를 선택해 주십시오.');
            return;
        }

        props.setMngrDataList(mngrDataList);
        props.setModalIsOpen(false);
    }

    const fn_onShow = () => {
        let userSeqList:any = []
        props.mngrDataList.map((data: any) => {
            userSeqList.push(data.userSeq);
        })
        console.log('md props: ', props);

        setMngrDataList(props.mngrDataList);
        setUserSeqList(userSeqList);
        setIsCodeDataLoaded(false);

    }

    return (
        <div>

            <Modal
                className="bmc-modal sub" size="xl"
                show={props.modalIsOpen}
                onShow={() => {
                    fn_onShow()

                }}
                onHide={fn_closeModal}
            >


                <Modal.Header>
                    <div className="d-flex justify-content-between align-items-center w-100 bmc-font-SD">
                        관리자 검색
                        <IoMdClose className='hover:cursor-pointer' onClick={fn_closeModal}/>
                    </div>
                </Modal.Header>

                <Modal.Body className="px-4">

                        <SHSearch datatable={datatable} formRef={searchFormRef} btnType={'p'}>
                            <BMCInput type={'hidden'} name={'isMngr'} value={true}></BMCInput>
                            <BMCInput type={'hidden'} name={'dprtCd'} value={props.dprtCd || ''}></BMCInput>

                            {props.companyGbCd == "C001001" ?
                                <BMCInput type={'hidden'} name={'authGrpId'} value={'HEAD'}></BMCInput>
                                : <BMCInput type={'hidden'} name={'authGrpId'} value={'SITE'}></BMCInput>
                            }
                            <Row>
                                <Col>
                                    <Table className="bmc-font-SP bmc-fs-b2 my-3">
                                        <tbody>
                                        <tr className="border-top align-middle">
                                            <th className="bmc-bg-th" style={{width: '6%'}}>업체명</th>
                                            <td style={{width: '27%'}}>

                                                {props.companyGbCd == "C001001" ?
                                                    <BMCInput value={"부산도시공사"} disabled={true} className={'form-control'}></BMCInput>
                                                    : <BMCSelect initOptionGb={'none'} name={'blngCmpnySeq'} className={'form-select'}
                                                                selParam={{companySeq: props.cmpnySeq}}
                                                                disabled={true} codeGb={'cmpny'}
                                                                setIsCodeDataLoaded={setIsCodeDataLoaded}
                                                    ></BMCSelect>
                                                }

                                            </td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </Col>

                            </Row>
                        </SHSearch>
                    <div className={'ge-result'}>
                        <Datatables
                            dataUrl={'/admin/api/user/retrieveUserDataListWithView'}
                            parameterFormRef={searchFormRef}
                            checkedDataList={userSeqList}
                            pk={'userSeq'}
                            columns={
                                props.companyGbCd == "C001001" ?
                                [
                                {data: "userName", title: "이름", textAlign: 'left'},
                                {data: "dprtNm", title: "소속부서", textAlign: 'center'},
                                {data: "userPhoneReg", title: "전화번호", textAlign: 'center'},
                            ] : [{data: "userName", title: "성명"},
                                        {data: "userId", title: "ID"},
                                        {data: "userPhoneReg", title: "전화번호"},
                                        {data: "companyName", title: "소속업체"},

                                        ]

                        }
                            checked={true}
                            isSingleCheck={false}
                            onLoad={(dt: any) => {
                                setDatatable(dt)
                            }}
                            onAllCheckedClick={(datas: any, checked: any)=>{
                                console.log(datas)
                                console.log('checked: ', checked);
                                let cstmUserSeqList = userSeqList;
                                let cstmMngrDataList = mngrDataList;

                                if(checked){
                                    datas.map((data: any) => {
                                        if(cstmUserSeqList.indexOf(data.userSeq) == -1){
                                            cstmUserSeqList.push(data.userSeq);
                                            cstmMngrDataList.push(data);
                                        }
                                    })
                                }else{
                                    datas.map((data: any) => {
                                        const idx = cstmUserSeqList.indexOf(data.userSeq);

                                        if(cstmUserSeqList.indexOf(data.userSeq) > -1){
                                            cstmUserSeqList.splice(idx, 1);
                                            cstmMngrDataList.splice(idx, 1);
                                        }
                                    })
                                }
                            }}
                            onClick={(data) => {
                                console.log('on clicked');
                                let cstmUserSeqList = userSeqList;
                                let cstmMngrDataList = mngrDataList;
                                const idx = cstmUserSeqList.indexOf(data.userSeq);

                                if(data.isChecked){
                                    if(idx == -1){
                                        cstmUserSeqList.push(data.userSeq)
                                        cstmMngrDataList.push(data);

                                    }
                                }else{
                                    if(idx > -1){
                                        cstmUserSeqList.splice(idx, 1);
                                        cstmMngrDataList.splice(idx, 1);
                                    }
                                }
                                // @ts-ignore
                                setUserSeqList([].concat(cstmUserSeqList));
                                setMngrDataList([].concat(cstmMngrDataList));

                            }
                            }
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="py-2">
                    <div className='flex justify-center w-100'>
                        <button
                            className='bmc-btn pill l white me-3'
                            onClick={fn_closeModal}>닫기
                        </button>
                        <button onClick={fn_select}
                                className='bmc-btn pill p'>선택

                        </button>
                    </div>
                </Modal.Footer>


            </Modal>
        </div>
    )
}

export default MngrSrchModal;
